import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["onMouseenter", "onMousemove", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", {
    ref: "itemListEl",
    class: _normalizeClass(["item-list", [_ctx.isOpen ? 'expanded' : '']]),
    style: _normalizeStyle({
            display: _ctx.isOpen ? 'block' : 'none',
            'max-height': _ctx.MAX_LIST_HEIGHT + 'px',
        })
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemList, (item, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: item.key,
        class: _normalizeClass([index === _ctx.currentHighlight ? 'active' : '']),
        onMouseenter: ($event: any) => (_ctx.setHighlighted(index, false)),
        onMousemove: ($event: any) => (_ctx.setHighlighted(index, false)),
        onClick: _withModifiers(($event: any) => (_ctx.click(item)), ["stop"])
      }, [
        (_ctx.showFlags)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(`country-flag fi fi-${String(item.key).toLowerCase()}`)
            }, null, 2))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(item.value), 1)
      ], 42, _hoisted_1))
    }), 128))
  ], 6))
}